import React, { useState, useEffect } from 'react';
import { Theme } from '@mui/material/styles';
import { Typography } from "@mui/material";
import Renderers from "~common/lib/renderers";
import { makeStyles, createStyles } from "@mui/styles";
import PortalUserContext from "~common/lib/portal-user-context";


const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            paddingLeft: 15,
        },
        sectionTitle: {
            color: "#555", 
            marginBottom: 20, 
            fontSize: "1.15rem", 
            marginTop: 20
        },
        myAlternatesMessage: {
            marginLeft: 10
        },
        myAlternatesLink: {
            cursor: "pointer",
            color: "blue"
        }
    })
);

export const OutOfOfficeAlternatePreferences: React.FC<any> = ({ 
    
 }) => {

    const classes = useStyles();

    const myAlternatesList = () => {
        window.location.href = "/users/out-of-office-alternates"
    }

    if (!PortalUserContext.hasOneOfFeatures(["non_po_approval"])) {
        return null
    }
    
    return (
        <div className={classes.container}>
            <Typography className={classes.sectionTitle} variant="h6" >Out Of Office Alternates</Typography>
                <Typography className={classes.myAlternatesMessage} variant="subtitle1">
                    Click <a className={classes.myAlternatesLink} onClick={myAlternatesList}>here</a> to manage your out of office alternates.
                </Typography>
        </div>
    )
 }

 OutOfOfficeAlternatePreferences.register = () => {
    if (!Renderers.find("outOfOfficeAlternates")) {
        Renderers.register("outOfOfficeAlternates", OutOfOfficeAlternatePreferences);
    }
}

 export default OutOfOfficeAlternatePreferences;